import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_BlockListSetup } from "../../../shared/data.service";

@Component({
	selector: "app-sba-add-group",
	templateUrl: "./sba-add-group.component.html",
	styleUrls: ["./sba-add-group.component.css"],
})
export class SbaAddGroupComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private dataService: DataService_BlockListSetup) {}
	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.lstSelected = this.dialogConfig.data.lstSelected;

		this.loadTable();
	}

	///////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////

	SchoolID: number = -1;

	TableLoading: boolean = false;
	lstSelected: any = [];
	lstTable: any = [];
	pagerows: any = 10;
	pagefirst: any = 0;

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////

	loadTable() {
		this.TableLoading = true;

		var result = this.dataService.SBAInsertGroupSelectList(this.SchoolID, -1);
		result.subscribe(
			(response) => {
				this.lstTable = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////

	onAdd() {
		this.ref.close({ lstSelected: this.lstSelected });
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true;
	}

	///////////////////////////////////////////////////////////
}
